import React from 'react'
import styles from '../styles/faqs.module.css';
import pigeonLogo from '../images/pigeonLogo.png';

function Disclaimer() {
  return (
    <div className={styles.card}>
      <img src={pigeonLogo} style={{ objectFit: 'contain' }} />
      <h2>Disclaimer</h2>
      <p style={{
        fontSize: "20px"
      }}>
        If you require any more information or have any questions about my site's disclaimer, please feel free to contact us by email at sahilsahacode@gmail.com
        <br />
        Disclaimers for Pigeon.rocks
        <br />
        All the information on this website - https://pigeon.rocks - is published in good faith and for general information purpose only. pigeon.rocks does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (pigeon.rocks), is strictly at your own risk. pigeon.rocks will not be liable for any losses and/or damages in connection with the use of our website.
        <br />
        <br />
        The website is made for receiving feedbacks only, Please do not use it to spread hate, or to disgust someone.
        <br />
        <br />
        pigeon.rocks will not be liable for any losses and/or damages in connection with the use of our website.
        <br />
        <br />
        From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.
        <br />
        <br />
        Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.
      </p>
    </div>
  )
}

export default Disclaimer
